import React, { useState } from 'react';
import { Modal, Button } from 'antd';
export default function UnApproveModal(props) {
    var _a = useState(props.isVisible), visible = _a[0], setVisible = _a[1];
    return (React.createElement(Modal, { title: "\u8BD5\u7528\u7533\u8BF7\u5BA1\u6838\u4E2D", okText: "\u597D\u7684", visible: visible, onCancel: function () {
            setVisible(false);
        }, footer: [
            React.createElement(Button, { key: "back", onClick: function () {
                    setVisible(false);
                } }, "\u597D\u7684"),
        ], width: 360, style: { top: '30%' } },
        React.createElement("p", null, "\u60A8\u7684\u8BD5\u7528\u7533\u8BF7\u6B63\u5728\u5BA1\u6838\u4E2D\uFF0C\u8BF7\u60A8\u8010\u5FC3\u7B49\u5F85\u3002\u5982\u6709\u95EE\u9898\u8BF7\u8054\u7CFB\uFF1A400-615-1212")));
}
//# sourceMappingURL=UnApproveModal.js.map